module.exports = __webpack_public_path__ + "img/funnel.2c4c98ad.svg";